<script setup>
import { ref, onMounted } from 'vue'
import Popper from 'vue3-popper'

const icon = ref(null)

const props= defineProps([
    'iconSrc',
    'content',
    'class',
    'hoverColor'
])

const onMouseEnter = () => {
    if (window.innerWidth > 1199) {
        icon.value.style.backgroundColor = props.hoverColor
        icon.value.classList.add('hover')
    }
}

const onMouseLeave = () => {
   if (window.innerWidth > 1199) {
       icon.value.style.backgroundColor = 'transparent'
       icon.value.classList.remove('hover')
   }
}

onMounted( () => {
    if (window.innerWidth < 1199) {
        icon.value.style.backgroundColor = props.hoverColor
    }
})
</script>

<template>
    <Popper hover arrow :class="class">
        <div class="icon" ref="icon" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
            <img :src="iconSrc" alt="">
        </div>
        <template #content>
            <div>{{ content }}</div>
        </template>
    </Popper>
</template>
